var sal = require('sal.js')

sal({threshold: 0.33,});
